module.exports = __webpack_public_path__ + "img/exam-zh-erased.49f0176f.webp";